const STORAGE_KEY = 'parentSchoolSession';

const resolveSchoolId = (user) => {
  const id = user?.schooleId || user?.schoolId;
  return id && typeof id === 'object' ? id._id : id;
};

export function saveParentSchoolSessionBeforeSwitch(childSchool) {
  if (isViewingChildSchool()) return;

  try {
    const userDetail = JSON.parse(localStorage.getItem('userDetail') || '{}');
    const token = localStorage.getItem('id_token');
    const parentSchoolId = resolveSchoolId(userDetail);

    if (!token || !parentSchoolId) return;
    if (String(parentSchoolId) === String(childSchool._id)) return;

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        userDetail,
        token,
        parentSchoolId: String(parentSchoolId),
        parentSchoolName: userDetail.name || '',
        childSchoolId: childSchool._id,
        childSchoolName: childSchool.schooleName || childSchool.name || '',
      }),
    );
  } catch (e) {
    console.error('Failed to save parent school session', e);
  }
}

export function getParentSchoolSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isViewingChildSchool() {
  const session = getParentSchoolSession();
  if (!session?.parentSchoolId) return false;

  try {
    const current = JSON.parse(localStorage.getItem('userDetail') || '{}');
    const currentId = resolveSchoolId(current);
    return Boolean(currentId && String(currentId) !== String(session.parentSchoolId));
  } catch {
    return false;
  }
}

export function restoreParentSchoolSession() {
  const session = getParentSchoolSession();
  if (!session?.userDetail || !session?.token) return false;

  localStorage.setItem('userDetail', JSON.stringify(session.userDetail));
  localStorage.setItem('id_token', session.token);
  localStorage.removeItem(STORAGE_KEY);
  return true;
}

export function clearParentSchoolSession() {
  localStorage.removeItem(STORAGE_KEY);
}
